import React, { useState, useEffect, useCallback, memo } from 'react';
import { Link, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { Botao } from 'components';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { lojaAberta } from 'utils';
import { CardapioHeaderHorario } from '../cardapio-header-horario';
import { useStyle } from './cardapio-header-info-styles';
import { HorarioDiaModel } from 'api/cardapio/models/horario/horario-dia-model';
import classNames from 'classnames';
import { CardapioDadosProps } from '../../cardapio-header-props';
import { phoneMask } from 'utils/phone-mask';
import { stringNumeros } from 'utils/string-numeros';
import { VariaveisAmbiente } from 'ambiente';
import { TelefoneIcon } from 'components/icons/telefone-icon';
import { RestauranteIcon } from 'components/icons/restaurante-icon';
import { LocalizacaoIcon } from 'components/icons/localizacao-icon';

export interface CardapioHeaderInfoProps {
  empresa: CardapioDadosProps | undefined;
  idValido: boolean;
}

export const CardapioHeaderInfoComp = ({ empresa: dados, idValido }: CardapioHeaderInfoProps) => {
  const classes = useStyle({
    dados,
    idValido
  });
  const [modalHorarioAberto, setAberto] = useState(false);
  const [endereco, setEndereco] = useState('');
  const [segmento, setSegmento] = useState('');
  const [carregandoInfo, setCarregandoInfo] = useState(true);

  const [horarios, setHorarios] = useState<HorarioDiaModel[]>([]);

  const showHorarioFuncionamento = useCallback(() => {
    setAberto(true);
  }, []);

  const hideHorarioFuncionamento = useCallback(() => {
    setAberto(false);
  }, []);
  //controle do horário

  const empresa = dados?.empresa
  const statusLoja = lojaAberta(dados?.horarioFuncionamento!)

  const capitalize = useCallback((value: any) => {
    if (value === undefined)
      return 'ERRO AO PEGAR VALOR';
    let splitted = value.split(' ');
    let formatado = '';
    splitted.forEach((element: string) => {
      formatado = formatado.concat(' ' + element.charAt(0).toUpperCase() + element.slice(1));
    });
    return formatado;
  }, []);

  const enderecoFormatado = useCallback(() => {
    if (empresa?.logradouro === undefined)
      return "Logradouro não definido";

    if (empresa?.logradouro === null)
      return "Logradouro não definido";

    return `${capitalize(empresa?.logradouro?.toLowerCase())}, 
    ${capitalize(empresa?.numero?.toLowerCase())} -
    ${capitalize(empresa?.bairro?.toLowerCase())}, 
    ${capitalize(empresa?.municipio?.toLowerCase())}/${empresa?.uf}`;
  }, [
    capitalize,
    empresa?.bairro,
    empresa?.logradouro,
    empresa?.municipio,
    empresa?.numero,
    empresa?.uf,
  ]);

  //controle endereço
  useEffect(() => {
    if (empresa?.id && empresa) {
      setEndereco(enderecoFormatado());
      setSegmento(empresa?.segmento);
      setHorarios(dados?.horarioFuncionamento?.empresaHorarioDias ?? [])
      setCarregandoInfo(false);
    }
    else
      setCarregandoInfo(false);
  }, [dados?.horarioFuncionamento?.empresaHorarioDias, empresa, enderecoFormatado]);

  const redirectToMaps = useCallback(() => {
    return `http://maps.google.com/maps?q=${enderecoFormatado().replace(' ', '%20')}`;
  }, [enderecoFormatado]);

  const redirectToWhatsapp = useCallback(() => {
    const numero = stringNumeros(empresa?.fone || '');
    if (!numero) return;
    const url = VariaveisAmbiente.whatsAppLink
      .replace('@telefone', `55${numero}`)
      .replace('@mensagem', '')
      .replace(' ', '%20');
    return url
  }, [empresa?.fone]);

  return (
    <div className={
      classNames(
        classes.root,
        idValido ? classes.centralizar : '',
        idValido && statusLoja
          ? classes.removeMargin
          : ''
      )
    }>
      {!idValido && (
        <div className={carregandoInfo ? classes.informacoesCarregando : classes.informacoes}>
          {carregandoInfo ? (
            <Skeleton />
          ) : (
            <Typography variant="body1" component="h2" gutterBottom>
              <div className={classes.textoInfo}>
                <div className={classes.iconInfo}>
                  <RestauranteIcon tipo="BUTTON" />
                </div>
                {segmento}
              </div>
            </Typography>
          )}
          {carregandoInfo ? (
            <Skeleton />
          ) : (
            <Link
              variant="body1"
              color="textPrimary"
              href={redirectToMaps()}
              target="_blank"
            >
              <div className={classes.textoInfo}>
                <div className={classes.iconInfo}>
                  <LocalizacaoIcon tipo="BUTTON" />
                </div>
                {endereco}
              </div>
            </Link>
          )}
          {carregandoInfo ? (
            <Skeleton />
          ) : empresa?.fone && (
            <Link
              variant="body1"
              color="textPrimary"
              href={stringNumeros(empresa?.fone || '').length > 0 ? redirectToWhatsapp() : ''}
              target="_blank"
            >
              <div className={classes.textoInfo}>
                <div className={classes.iconInfo}>
                  <TelefoneIcon tipo="BUTTON" />
                </div>
                {phoneMask(empresa?.fone ?? '')}
              </div>
            </Link>
          )}
        </div>
      )}

      {statusLoja && idValido ? null : (
        <div className={classes.horarioContainer}>
          <Botao
            onClick={showHorarioFuncionamento}
            disabled={carregandoInfo}
            size="small"
            carregando={carregandoInfo}
            startIcon={!carregandoInfo ? <AccessTimeIcon /> : null}
          >
            {!carregandoInfo ? (statusLoja ? 'Aberto' : 'Fechado') : ''}
          </Botao>
          <CardapioHeaderHorario
            aberto={modalHorarioAberto}
            horarios={horarios}
            quandoForFechado={hideHorarioFuncionamento}
          />
        </div>
      )}
    </div>
  );
};
export const CardapioHeaderInfo = memo(CardapioHeaderInfoComp);
